import { yup } from '@framework/validation';
import { mapValues } from 'lodash';
import { DefaultAssignableExpressionSchema } from '../../../../expressions/repository/assignable/AssignableExpressionSchema';
import { IAssignableExpression } from '../../../../expressions/repository/assignable/IAssignableExpression';
import { IAsyncServiceParameter } from '../../../../expressions/repository/async/context/IAsyncService';
import { WidgetType } from '../../../Widget';
import { AsyncSelectTableConfigSchema } from '../async-select/AsyncSelectConfigSchema';
import { CommonInputWidgetConfigSchema } from '../common/CommonInputConfigComponent';
import { IAsyncTableWidget } from './IAsyncTableWidget';

export const AsyncTableConfigSchema: yup.ObjectSchema<IAsyncTableWidget> =
  CommonInputWidgetConfigSchema.shape({
    // Non c'è l'etichetta per la tabella
    label: yup.mixed().strip(),
    type: yup.string().exact(WidgetType.AsyncTable).required(),
    serviceId: yup.string().required().label('Servizio'),
    inputs: yup.lazy(obj => {
      return yup
        .object<Record<string, IAssignableExpression>>(
          mapValues(
            obj ?? {},
            (value, key) => DefaultAssignableExpressionSchema,
          ),
        )
        .required()
        .label('Parametri');
    }),
    outputs: yup
      .array(yup.object() as yup.ObjectSchema<IAsyncServiceParameter>)
      .label('Risultati')
      .optional(),
    table: AsyncSelectTableConfigSchema,
  })
    .required()
    .noUnknown();
